// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
// It's faked dva
// aliased to @umijs/plugins/templates/dva
import { create, Provider } from '/opt/buildhome/repo/node_modules/.pnpm/@umijs+plugins@4.6.82_@babel+core@7.29.7_supports-color@10.2.2__@types+react-dom@19.2.3_f7db5dd9b407f9800d8307af5484805c/node_modules/@umijs/plugins/libs/dva.tsx';
import createLoading from '/opt/buildhome/repo/node_modules/.pnpm/dva-loading@3.0.25_dva-core@2.0.4_redux@4.2.1_/node_modules/dva-loading/dist/index.js';

import dvaImmer, { enableES5, enableAllPlugins } from '/opt/buildhome/repo/node_modules/.pnpm/dva-immer@1.0.2_dva@2.6.0-beta.23_react-dom@19.2.8_react@19.2.8__react-router@5.3.4_react@19.2.8__react@19.2.8_/node_modules/dva-immer/dist/index.js';

import React, { useRef } from 'react';
import { history, ApplyPluginsType, useAppData } from 'umi';
import { models } from './models';

let dvaApp: any;

export function RootContainer(props: any) {
  const { pluginManager } = useAppData();
  const app = useRef<any>();
  const runtimeDva = pluginManager.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  if (!app.current) {
    app.current = create(
      {
        history,
        ...(runtimeDva.config || {}),
      },
      {
        initialReducer: {},
        setupMiddlewares(middlewares: Function[]) {
          return [...middlewares];
        },
        setupApp(app: IDvaApp) {
          app._history = history;
        },
      },
    );
    dvaApp = app.current;
    app.current.use(createLoading());
    app.current.use(dvaImmer());
    enableES5();
    
    (runtimeDva.plugins || []).forEach((p) => {
      app.current.use(p);
    });
    for (const id of Object.keys(models)) {
      app.current.model({
        namespace: models[id].namespace,
        ...models[id].model,
      });
    }
    app.current.start();
  }
  return <Provider store={app.current!._store}>{props.children}</Provider>;
}

export function getDvaApp() {
  return dvaApp;
}
